const productCache = new Map();
const imagePreloadCache = new Map();

const animateImageSwap = (oldImage, newImage, secondaryImage = null) => {
  return new Promise((resolve) => {
    if (!oldImage || !newImage) {
      resolve();
      return;
    }

    const parent = oldImage.parentNode;
    if (!parent) {
      resolve();
      return;
    }

    if (secondaryImage && secondaryImage.parentNode) {
      secondaryImage.style.transition =
        "opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), transform 180ms cubic-bezier(0.4, 0, 0.2, 1), filter 180ms cubic-bezier(0.4, 0, 0.2, 1)";
      secondaryImage.style.opacity = "0";
      secondaryImage.style.transform = "scale(1)";
      secondaryImage.style.filter = "blur(0px)";
      secondaryImage.style.pointerEvents = "none";
    }

    newImage.style.opacity = "0";
    newImage.style.transform = "scale(1.035)";
    newImage.style.filter = "blur(10px)";
    newImage.style.transition =
      "opacity 420ms cubic-bezier(0.22, 1, 0.36, 1), transform 420ms cubic-bezier(0.22, 1, 0.36, 1), filter 420ms cubic-bezier(0.22, 1, 0.36, 1)";

    oldImage.style.transition =
      "opacity 320ms cubic-bezier(0.4, 0, 0.2, 1), transform 320ms cubic-bezier(0.4, 0, 0.2, 1), filter 320ms cubic-bezier(0.4, 0, 0.2, 1)";

    parent.insertBefore(newImage, oldImage.nextSibling);

    requestAnimationFrame(() => {
      oldImage.style.opacity = "0";
      oldImage.style.transform = "scale(0.985)";
      oldImage.style.filter = "blur(8px)";

      requestAnimationFrame(() => {
        newImage.style.opacity = "1";
        newImage.style.transform = "scale(1)";
        newImage.style.filter = "blur(0)";
      });
    });

    setTimeout(() => {
      if (oldImage.parentNode) oldImage.remove();
      if (secondaryImage && secondaryImage.parentNode) secondaryImage.remove();

      newImage.style.transition = "";
      newImage.style.transform = "";
      newImage.style.filter = "";
      newImage.style.opacity = "";
      newImage.style.pointerEvents = "";

      resolve();
    }, 430);
  });
};

const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "eager";
  newImage.decoding = "async";
  return newImage;
};

const preloadImage = (src, srcset = "") => {
  if (!src) return Promise.resolve(null);

  const cacheKey = `${src}__${srcset}`;
  if (imagePreloadCache.has(cacheKey)) {
    return imagePreloadCache.get(cacheKey);
  }

  const img = new Image();
  img.decoding = "async";

  const promise = new Promise((resolve) => {
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
  });

  if (srcset) img.srcset = srcset;
  img.src = src;

  imagePreloadCache.set(cacheKey, promise);
  return promise;
};

const getProductData = (handleProduct) => {
  if (productCache.has(handleProduct)) {
    return Promise.resolve(productCache.get(handleProduct));
  }

  return new Promise((resolve, reject) => {
    jQuery
      .getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
        productCache.set(handleProduct, product);
        resolve(product);
      })
      .fail(reject);
  });
};

const getVariantByColor = (product, color) => {
  return product.variants.find(
    (item) => item.featured_media != null && item.options.includes(color)
  );
};

const preloadVariantImageByColor = async (handleProduct, color) => {
  try {
    const product = await getProductData(handleProduct);
    const variant = getVariantByColor(product, color);

    if (!variant?.featured_media?.preview_image) {
      return null;
    }

    const previewImage = variant.featured_media.preview_image;
    const srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);

    await preloadImage(previewImage.src, srcset);

    return { product, variant };
  } catch (error) {
    console.error("Preload failed:", error);
    return null;
  }
};

const preloadWrapperVariantImages = async (wrapper) => {
  const handleProduct = wrapper.dataset.product;
  if (!handleProduct) return;

  const inputs = wrapper.querySelectorAll(".js-color-swatches input");

  try {
    const product = await getProductData(handleProduct);

    inputs.forEach((input) => {
      const variant = getVariantByColor(product, input.value);
      if (!variant?.featured_media?.preview_image) return;

      const previewImage = variant.featured_media.preview_image;
      const srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
      preloadImage(previewImage.src, srcset);
    });
  } catch (error) {
    console.error("Wrapper preload failed:", error);
  }
};

const bindSwatchEvents = (wrapper) => {
  if (wrapper.dataset.swatchesBound === "true") return;
  wrapper.dataset.swatchesBound = "true";

  const inputs = wrapper.querySelectorAll(".js-color-swatches input");

  wrapper.dataset.switchRequestId = "0";
  wrapper.dataset.pendingColor = "";
  wrapper.dataset.activeColor = "";

  preloadWrapperVariantImages(wrapper);

  const runVariantSwitch = async () => {
    if (wrapper.dataset.isSwitching === "true") return;

    const pendingColor = wrapper.dataset.pendingColor;
    if (!pendingColor) return;

    const handleProduct = wrapper.dataset.product;
    const primaryImage = wrapper.querySelector(".media--first");
    const secondaryImage = wrapper.querySelector(".media--second");
    const activeInput = wrapper.querySelector(`.js-color-swatches input[value="${CSS.escape(pendingColor)}"]`);

    if (!handleProduct || !primaryImage || !activeInput) return;

    wrapper.dataset.isSwitching = "true";

    const requestId = String(Number(wrapper.dataset.switchRequestId || "0") + 1);
    wrapper.dataset.switchRequestId = requestId;

    try {
const variantLink = activeInput.dataset.variantLink;

if (variantLink) {
  wrapper.querySelectorAll('a[href]').forEach((link) => {
    if (
      link.classList.contains("js-color-swatches-link") ||
      link.closest(".card__title") ||
      link.classList.contains("card__more") ||
      link.classList.contains("full-unstyled-link")
    ) {
      link.setAttribute("href", variantLink);
    }
  });
}

      const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
      if (addButton) {
        addButton.setAttribute("aria-disabled", "false");

        const defaultLabel = addButton.querySelector("span");
        const soldOutMessage = addButton.querySelector(".sold-out-message");
        const variantIdInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');

        if (defaultLabel) defaultLabel.classList.remove("hidden");
        if (soldOutMessage) soldOutMessage.classList.add("hidden");
        if (variantIdInput && activeInput.dataset.variantId) {
          variantIdInput.value = activeInput.dataset.variantId;
        }
      }

      const data = await preloadVariantImageByColor(handleProduct, pendingColor);

      if (!data) return;

      if (wrapper.dataset.switchRequestId !== requestId) return;
      if (wrapper.dataset.pendingColor !== pendingColor) return;

      const { product, variant } = data;

      const latestPrimaryImage = wrapper.querySelector(".media--first");
      const latestSecondaryImage = wrapper.querySelector(".media--second");

      if (!latestPrimaryImage) return;

      const newPrimaryImage = createImageElement(
        variant["featured_media"],
        latestPrimaryImage.className,
        latestPrimaryImage.sizes,
        product.title
      );

      const currentPrimarySrc = latestPrimaryImage.currentSrc || latestPrimaryImage.src;
      const nextPrimarySrc = newPrimaryImage.currentSrc || newPrimaryImage.src;

      if (nextPrimarySrc === currentPrimarySrc) {
        wrapper.dataset.activeColor = pendingColor;
        return;
      }

      await animateImageSwap(latestPrimaryImage, newPrimaryImage, latestSecondaryImage);

      if (wrapper.dataset.switchRequestId !== requestId) return;

      wrapper.dataset.activeColor = pendingColor;
    } catch (error) {
      console.error("Variant switch failed:", error);
    } finally {
      wrapper.dataset.isSwitching = "false";

      const pendingAfter = wrapper.dataset.pendingColor;
      const activeAfter = wrapper.dataset.activeColor;

      if (pendingAfter && pendingAfter !== activeAfter) {
        requestAnimationFrame(() => {
          runVariantSwitch();
        });
      }
    }
  };

  inputs.forEach((input) => {
    const warmup = () => {
      const handleProduct = wrapper.dataset.product;
      const color = input.value;
      preloadVariantImageByColor(handleProduct, color);
    };

    input.addEventListener("mouseenter", warmup, { passive: true });
    input.addEventListener("touchstart", warmup, { passive: true });

    input.addEventListener("change", (event) => {
      const target = event.currentTarget;
      if (!target.checked) return;

      wrapper.dataset.pendingColor = target.value;
      runVariantSwitch();
    });
  });
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    bindSwatchEvents(wrapper);
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();